export class AlternateContactDto {
    Email: string
    FirstName: string
    LastName: string
    Phone: string
    StrategyId: number;
}